
define('text!modules/creatives/display/templates/createT1AS.html',[],function () { return '<div class="w-CreativesCreateEdit w-CreateEditForm w-box w-DisplayAdd">\n    <div class="w-head">\n        <div class="title"><div class="icon"></div>Upload New T1AS Hosted Assets (Step 1 of 2)</div>\n    </div>\n    <div class="w-body check-radio-forms"></div>\n    {{>footer}}\n</div>\n';});

